import Vue, { ref } from 'vue'
import { GroupApiAdapter } from '../Adapters/GroupApiAdapter'
import { defineLoadableStore } from '@internal-libraries/kheops-ui-lib'
import Group from '../Classes/Group'

export const useGroupStore = defineLoadableStore(
    'group',
    () => {
        const groups = ref<Group[]>([])
        const loadGroups = () => {
            return Vue.$http.get('api/v1/group/groups', new GroupApiAdapter()).toPromise()
        }

        return {
            groups,
            loadGroups,
        }
    },
    async store => {
        store.groups.value = (await store.loadGroups()).getManyData() || []
    },
)
